<template>
    <div>
        <app-overlay-loader v-if="preloader"/>
        <form v-else ref="form">
            <app-form-group
                page="page"
                :label="$t('first_name')"
                type="text"
                v-model="formData.first_name"
                :placeholder="$placeholder('first_name','')"
                :error-message="$errorMessage(errors, 'first_name')"
            />
            <app-form-group
                page="page"
                :label="$t('last_name')"
                type="text"
                v-model="formData.last_name"
                :placeholder="$placeholder('last_name','')"
                :error-message="$errorMessage(errors, 'last_name')"
            />
            <app-form-group
                page="page"
                :label="$t('email')"
                type="text"
                v-model="formData.email"
                :placeholder="$placeholder('email','')"
                :error-message="$errorMessage(errors, 'email')"
            />
            <app-form-group
                page="page"
                :label="$t('employee_id')"
                type="text"
                v-model="formData.employee_id"
                :placeholder="$placeholder('employee_id','')"
                :error-message="$errorMessage(errors, 'employee_id', true, true)"
            />
            <app-form-group
                page="page"
                :label="$t('phone_number')"
                type="tel-input"
                v-model="formData.phone_number"
                :placeholder="$placeholder('phone_number','')"
                :error-message="$errorMessage(errors, 'phone_number')"
            />
            <app-form-group
                page="page"
                :label="$t('gender')"
                type="radio"
                :list="[
                    {id:'male',value: $t('male')},
                    {id:'female', value:  $t('female')},
                    {id:'other', value:  $t('others')}
                ]"
                v-model="formData.gender"
                :error-message="$errorMessage(errors, 'gender')"
            />
            <app-form-group
                page="page"
                :label="$t('birthday')"
                type="date"
                v-model="formData.date_of_birth"
                :placeholder="$placeholder('date_of_birth','')"
                :error-message="$errorMessage(errors, 'date_of_birth')"
            />
            <app-form-group
                page="page"
                :label="$t('about_me')"
                type="textarea"
                v-model="formData.about_me"
                :placeholder="$textAreaPlaceHolder('about_me','')"
                :error-message="$errorMessage(errors, 'about_me')"
            />
            <app-form-group
                page="page"
                :label="$t('access_platform')"
                type="select"
                :list="[
                    {id: 1,value: $t('web')},
                    {id: 2, value:  $t('app')},
                    {id: 3, value:  $t('both')}
                ]"
                v-model="formData.access_platform"
                :error-message="$errorMessage(errors, 'access_platform')"
            />
            <app-form-group
                page="page"
                :label="$t('attendance_type')"
                type="select"
                :list="[
                    {id: 'face', value: $t('face')},
                    {id: 'qr', value: $t('qr')},
                    {id: 'location', value: $t('location')},
                    {id: 'nfc', value: $t('nfc')},
                    {id: 'photo', value: $t('photo')},
                    {id: 'all', value: $t('all')}
                ]"
                v-model="formData.attendance_type"
                :error-message="$errorMessage(errors, 'attendance_type')"
            />
            <app-form-group
                page="page"
                :label="$t('multi_device')"
                type="radio"
                :list="[
                    {id: 1, value: $t('yes')},
                    {id: 0, value: $t('no')}
                ]"
                v-model="formData.multi_device"
                :error-message="$errorMessage(errors, 'multi_device')"
            />

            <div class="form-group mt-5 mb-0">
                <app-submit-button @click="submitData" :title="$t('save')" :loading="loading"/>
            </div>
        </form>
    </div>

</template>
<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import {formatDateForServer} from "../../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {EMPLOYEES} from "../../../../../Config/ApiUrl";
import optional from "../../../../../../common/Helper/Support/Optional";
import {axiosPatch} from "../../../../../../common/Helper/AxiosHelper";

export default {
    name: "EmployeePersonalDetails",
    mixins: [FormHelperMixins],
    data() {
        return {
            formData: {},
            preloader: true
        }
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = {...this.formData};
            formData.date_of_birth = formatDateForServer(formData.date_of_birth);
            this.submitFromFixin(`patch`, `${EMPLOYEES}/${this.formData.id}/profile-update`, formData);
        },
        afterSuccess(response) {
            this.loading = false;
            this.$toastr.s('', response.data.message);
            this.scrollToTop(false)
            // setTimeout(() => location.reload())
        },
        toggleRequireProfileUpdate(value) {
            axiosPatch(`${EMPLOYEES}/${this.formData.id}/toggle-require-profile-update`, {
                require_profile_update: value ? 1 : 0
            }).then(response => {
                this.$toastr.s('', response.data.message);
            }).catch(error => {
                this.$toastr.e('', error.response?.data?.message || 'Error');
            });
        },
    },

    computed: {
        ...mapState({
            employeeDetails: state => state.employees.employee
        }),
    },

    watch: {
        employeeDetails: {
            handler: function (employee) {
                if (!!Object.keys(employee).length) {
                    this.preloader = false
                }

                this.formData = {
                    ...employee,
                    access_platform: employee.profile ? employee.profile.access_platform : 2,
                    employee_id: employee.profile ? employee.profile.employee_id : '',
                    gender: employee.profile ? employee.profile.gender : '',
                    about_me: employee.profile ? employee.profile.about_me : '',
                    phone_number: employee.profile ? employee.profile.phone_number : '',
                    date_of_birth: optional(employee, 'profile', 'date_of_birth') ? new Date(employee.profile.date_of_birth) : '',
                    attendance_type: employee.profile ? employee.profile.attendance_type : 'all',
                    multi_device: employee.profile ? employee.profile.multi_device : 0,
                    require_profile_update: employee.profile ? Boolean(employee.profile.require_profile_update) : false,
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
